// Common
import { Component, inject, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { LocalStorageItem, LSBoolean } from '@frontendlib/common/decorators/local-storage.decorator';
import { heightAnimation } from '@modules/common/animations/height.animation';

// Injection Tokens

// Services
import { TeamsService } from '@modules/settings/services/teams.service';

// Types
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';
import { Team } from '@modules/settings/types/team';
import { SplitViewService } from '@modules/split-view/services/split-view.service';

// RX
import { SpaceContextStore } from '@modules/common/services/SpaceContextStore';
import { applyInstanceDecorators, DeferInstanceDecorator } from '@sharedlib/common/lang/DeferInstanceDecorator';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'stch-side-bar-teams',
  templateUrl: './side-bar-teams.component.html',
  styleUrls: ['./side-bar-teams.component.less'],
  animations: [heightAnimation],
  standalone: false,
})
export class SidebarTeamsComponent implements OnInit, OnDestroy {
  public teams: Team[] = [];
  public minimized: boolean;

  @DeferInstanceDecorator(LSBoolean({ lsKey: 'sidebar-teams.collapsed' }))
  declare public readonly expanded: LocalStorageItem<boolean>;

  private alive = new Subject<void>();

  @Input() template: TemplateRef<any>;
  @Input() splitViewKey: SidebarSplitViewKey;

  private readonly spaceContextStore = inject(SpaceContextStore);
  private readonly teamsService = inject(TeamsService);
  private readonly splitViewService = inject(SplitViewService);

  constructor() {
    applyInstanceDecorators(this, SidebarTeamsComponent);
  }

  /**
   * Lifecycle
   */

  ngOnInit() {
    this.spaceContextStore.contextId$
      .pipe(
        switchMap((spaceId) => this.teamsService.findAll({ spaceId }, { cache: true })),
        takeUntil(this.alive),
      )
      .subscribe((teams) => {
        this.teams = teams;
      });

    this.splitViewService
      .getMinimized(this.splitViewKey)
      .pipe(takeUntil(this.alive))
      .subscribe((minimized) => {
        this.minimized = minimized;
      });
  }

  ngOnDestroy() {
    this.alive.next();
    this.alive.complete();
  }
}
